import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

const STARTER_CHORES = [
  { title: "Make bed", points: 3 },
  { title: "Brush teeth", points: 2 },
  { title: "Put away toys", points: 3 },
  { title: "Read for 15 minutes", points: 4 },
  { title: "Set the table", points: 3 }
];

const buildTask = (_familyId, chore) => ({
  title: chore.title,
  points: chore.points || 0,
  assignedTo: "unassigned",
  status: "open",
  frequency: "repeat",
  repeat: { type: "daily" },
  repeatType: "daily",
  showAfterTime: null,
  expiryTime: null,
  gracePeriodMins: 0,
  lastReset: new Date().setHours(0, 0, 0, 0),
  needsClarification: false,
  clarifications: []
});

export const addStarterChores = async ({ familyId, tasks = [] }) => {
  if (!familyId) return 0;
  const existing = new Set(
    tasks
      .map((task) => (task?.title || "").trim().toLowerCase())
      .filter(Boolean)
  );

  const choresToAdd = STARTER_CHORES.filter(
    (chore) => !existing.has(chore.title.toLowerCase())
  );

  if (choresToAdd.length === 0) return 0;
  const createFamilyTasks = httpsCallable(functions, "createFamilyTasks");
  await createFamilyTasks({
    familyId,
    tasks: choresToAdd.map((chore) => buildTask(familyId, chore))
  });
  return choresToAdd.length;
};
